import { formatINRCurrency } from "../../../../utilities/currency/currency";
import { getFormattedDateDDMMMYYYYDate } from "../../../../utilities/dateFunctions/formatdate";
import { number_in_words } from "../../../../utilities/generalFunctions/numberToWrod";
import sabccoLogo from "../../../../assets/SABCCO_128x128.png";

export const PrintBulkDemandNotice = ({ sendLoanReminderList }) => {
  return (
    <>
      <section className="p-5">
        {sendLoanReminderList?.map((loaneeDetails, index) => (
          <div key={index} className="page-break">
            <div className=" h-[100%] ">
              <div className="w-[95%] mx-auto flex justify-between items-center px-3 py-2 gap-3">
                <div className="flex gap-3 items-center">
                  <img className="h-16 w-16" src={sabccoLogo} />
                  <div>
                    <p className="text-center text-[14px] font-semibold">
                      Sikkim SC / ST / OBC Development Corporation.Ltd. (SABCCO)
                    </p>
                    <p className="text-[12px]  -mt-1">
                      Chorten Monastery Road, Deorali, Gangtok, Sikkim - 737102
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <section key={index} className="text-[14px] px-6">
              {/* Letter Header */}
              <div className="flex flex-wrap justify-between mb-4 gap-y-2">
                <p className="font-semibold">
                  Ref.No: {loaneeDetails?.reference_number || "NA"}
                </p>
                <p className="font-semibold">
                  Date: {getFormattedDateDDMMMYYYYDate(new Date())}
                </p>
              </div>

              {/* Recipient Details */}
              <div className="my-6 leading-tight">
                <p>To,</p>
                <p className="font-semibold break-words">
                  {loaneeDetails?.full_info?.applicantname}
                </p>
                <p className="font-semibold uppercase break-words">
                  {loaneeDetails?.full_info?.applicantrelative}:{" "}
                  {loaneeDetails?.full_info?.applicantrelativename}
                </p>
                <p className="font-semibold uppercase break-words">
                  {loaneeDetails?.full_info?.permanentaddress}
                </p>
              </div>

              {/* Subject */}
              <p className="underline font-semibold">
                Subject: Demand Notice for repayment of loan.
              </p>

              {/* Body Content */}
              <div className="mt-6 leading-relaxed">
                <p>Dear Sir/Madam,</p>
                <p className="mt-4">
                  This is to inform you that a sum of
                  <span className="font-semibold">
                    {formatINRCurrency(
                      (+loaneeDetails?.full_info?.interest_due_amount || 0) +
                        (+loaneeDetails?.full_info?.principle_due || 0) +
                        (+loaneeDetails?.penal_interest || 0) +
                        (+loaneeDetails?.interest_on_interest || 0),
                    )}
                  </span>{" "}
                  has fallen due for repayment against your{" "}
                  <span className="font-semibold">
                    {loaneeDetails?.full_info?.schemename}
                  </span>{" "}
                  loan ID.No:{" "}
                  <span className="font-semibold">
                    {loaneeDetails?.full_info?.loanee_id}
                  </span>{" "}
                  account with this Corporation. The detail of the amount
                  payable as on{" "}
                  <span className="font-semibold">
                    {getFormattedDateDDMMMYYYYDate(new Date())}
                  </span>{" "}
                  by you is given in the schedule below :
                </p>
              </div>

              {/* Schedule I */}
              <div className="grid grid-cols-2 ps-24 gap-6 pt-6">
                <div>
                  <h2 className="underline underline-offset-2 font-semibold">
                    Schedule I
                  </h2>
                  <ul className="list-decimal pl-6 pt-2 space-y-1">
                    <li>Principle Default</li>
                    <li>Interest due</li>
                    {loaneeDetails?.full_info?.categoryname === "OBC" && (
                      <>
                        <li>Penal Interest</li>
                        <li>Interest on Interest</li>
                      </>
                    )}
                  </ul>
                </div>

                <div>
                  <h2 className="underline underline-offset-2 font-semibold">
                    Amount
                  </h2>
                  <ul className="pt-2 space-y-1">
                    <li className="font-semibold">
                      {formatINRCurrency(
                        loaneeDetails?.full_info?.principle_due,
                      )}
                    </li>
                    <li className="font-semibold">
                      {formatINRCurrency(
                        loaneeDetails?.full_info?.interest_due_amount,
                      )}
                    </li>

                    {loaneeDetails?.full_info?.categoryname === "OBC" && (
                      <>
                        <li className="font-semibold">
                          {formatINRCurrency(+loaneeDetails?.penal_interest)}
                        </li>
                        <li className="font-semibold">
                          {formatINRCurrency(
                            +loaneeDetails?.interest_on_interest,
                          )}
                        </li>
                      </>
                    )}
                  </ul>

                  <p className="font-semibold pt-2">
                    Total :
                    {formatINRCurrency(
                      loaneeDetails?.full_info?.principle_outstanding +
                        loaneeDetails?.full_info?.interest_due_amount || 0,
                    )}
                  </p>
                </div>
              </div>

              <p className="pt-3 ml-6 font-semibold">
                (Rupees{" "}
                <span className="font-bold">
                  {number_in_words(
                    loaneeDetails?.full_info?.principle_outstanding +
                      loaneeDetails?.full_info?.interest_due_amount,
                  ) || 0}
                </span>{" "}
                only)
              </p>

              {/* Schedule II */}
              <div className="grid grid-cols-2 ps-24 gap-6 pt-6">
                <div>
                  <h2 className="underline underline-offset-2 font-semibold">
                    Schedule II
                  </h2>
                  <ul className="list-decimal pl-6 pt-2 space-y-1">
                    <li>Principle Outstanding</li>
                    <li>Interest due</li>
                    {loaneeDetails?.full_info?.categoryname === "OBC" && (
                      <>
                        <li>Penal Interest</li>
                        <li>Interest on Interest</li>
                      </>
                    )}
                  </ul>
                </div>

                <div>
                  <h2 className="underline underline-offset-2 font-semibold">
                    Amount
                  </h2>
                  <ul className="pt-2 space-y-1">
                    <li className="font-semibold">
                      {formatINRCurrency(
                        loaneeDetails?.full_info?.principle_due,
                      )}
                    </li>
                    <li className="font-semibold">
                      {formatINRCurrency(
                        loaneeDetails?.full_info?.interest_due_amount,
                      )}
                    </li>

                    {loaneeDetails?.full_info?.categoryname === "OBC" && (
                      <>
                        <li className="font-semibold">
                          {formatINRCurrency(+loaneeDetails?.penal_interest)}
                        </li>
                        <li className="font-semibold">
                          {formatINRCurrency(
                            +loaneeDetails?.interest_on_interest,
                          )}
                        </li>
                      </>
                    )}
                  </ul>

                  <p className="font-semibold pt-2">
                    Total:{" "}
                    {formatINRCurrency(
                      loaneeDetails?.full_info?.principle_due +
                        loaneeDetails?.full_info?.interest_due_amount || 0,
                    )}
                  </p>
                </div>
              </div>

              <p className="pt-3 ml-6 font-semibold">
                (Rupees{" "}
                <span className="font-bold">
                  {" "}
                  {number_in_words(
                    loaneeDetails?.full_info?.principle_due +
                      loaneeDetails?.full_info?.interest_due_amount,
                  ) || 0}
                </span>{" "}
                only)
              </p>

              {/* Final Paragraph */}
              <p className="mt-6 leading-relaxed">
                You are advised to settle the overdues indicated in the above
                schedule within 15 days from date of receipt of this notice...
                SPDR Act 1988/Lok Adalat.
                <br />
                Soliciting your kind co-operation.
              </p>

              {/* Signature Section */}
              <div className="flex justify-between flex-wrap pt-10 gap-y-6">
                <div>
                  <p>Name &amp; Signature of the recipient:</p>
                  <p className="font-semibold mt-12 break-words">
                    {loaneeDetails?.full_info?.applicantname}
                  </p>
                  <p className="font-semibold uppercase break-words">
                    {loaneeDetails?.full_info?.permanentaddress}
                  </p>

                  {loaneeDetails?.full_info?.guarantor && (
                    <>
                      <p className="pt-6">Copy To</p>
                      <p>
                        Guarantor Name:{" "}
                        <span className="font-semibold">
                          {loaneeDetails?.full_info?.guarantor?.name}
                        </span>
                      </p>
                      <p>
                        Guarantor Address:{" "}
                        <span className="font-semibold">
                          {loaneeDetails?.full_info?.guarantor?.address}
                        </span>
                      </p>
                    </>
                  )}
                </div>

                <div className="text-right">
                  <p>Yours faithfully,</p>
                  <p className="mt-12">Asstt. Manager/Manager/Dy.G.M</p>
                </div>
              </div>
            </section>
          </div>
        ))}
      </section>
    </>
  );
};
